<div class="card h-100 min-vh-79 profile-subscription-history__container">
  <div class="card-body row">
    <div class="col-md-12">
      <div class="pc-table">
        <ng-container [ngTemplateOutlet]="pcTable"></ng-container>
      </div>
      <div class="mb-table">
        <ng-container [ngTemplateOutlet]="mbTable"></ng-container>
      </div>

      <hr class="w-100 my-5">

      <ng-container *ngIf="isItemsSizeMoreThanMaxSize()">
        <div class="w-100 d-flex justify-content-end">
          <app-paginator
            [totalItems]="30"
            [pageSize]="10"
            [currentPage]="1"
            [maxVisiblePages]="3"
          >
          </app-paginator>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #pcTable>
  <div class="table-responsive">
    <table class="table">
      <thead>
      <tr>
        <th>Subscription</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>PDF</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let subscription of dummySubscriptionHistory">
        <td>
          {{ subscription.type | titlecase }}
        </td>
        <td>
          <div class="d-flex flex-column">
            <span>{{ subscription.startDate | date }}</span>
            <span class="text-gray">{{ subscription.startDate.getHours()}}:{{ subscription.startDate.getMinutes() }}</span>
          </div>
        </td>
        <td>
          <div class="d-flex flex-column">
            <span>{{ subscription.endDate | date }}</span>
            <span class="text-gray">{{ subscription.endDate.getHours()}}:{{ subscription.endDate.getMinutes() }}</span>
          </div>
        </td>
        <td class="download-pdf-td" (click)="downloadSubscriptionPDF(subscription)">
          <mat-icon class="download-icon">download_outline</mat-icon>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #mbTable>
  <div class="d-flex flex-column gap-3">
    <div *ngFor="let subscription of dummySubscriptionHistory">
      <div class="d-flex flex-column gap-1">
        <div class="d-flex flex-row justify-content-between">
          <span class="fs-4 fw-bold">{{ subscription.type | titlecase }}</span>
          <td class="download-pdf-td" (click)="downloadSubscriptionPDF(subscription)">
            <mat-icon class="download-icon">download_outline</mat-icon>
          </td>
        </div>
        <div class="d-flex flex-column gap-1">
          <div class="d-flex flex-row gap-1">
            <span class="text-gray">Start Date: </span>
            <span class="d-flex flex-row gap-1">
            <span>{{ subscription.startDate | date }}</span>
            <span class="text-gray">{{ subscription.startDate.getHours()}}:{{ subscription.startDate.getMinutes() }}</span>
          </span>
          </div>
          <div class="d-flex flex-row gap-1">
            <span class="text-gray">End Date: </span>
            <span class="d-flex flex-row gap-1">
            <span>{{ subscription.endDate | date }}</span>
            <span class="text-gray">{{ subscription.endDate.getHours()}}:{{ subscription.endDate.getMinutes() }}</span>
          </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
